export function toError(reason) {
  if (reason && reason.status === 403 && reason.data && reason.data.error_description === 'Missing Wix session') {
    reason.status = 401;
    reason.data.message = 'Wix Session required';
  }
  return Promise.reject(reason);
}